// The one browser Supabase client. Import it, don't make another:
//
//   import { supabase } from '../lib/supabaseClient'
//
// The client bundle sees exactly two build-time vars — VITE_SUPABASE_URL and
// VITE_SUPABASE_PUBLISHABLE_KEY. The publishable (anon) key is public by design;
// RLS is what protects the data. If you ever reach for a service-role, Google or
// Anthropic key in `src/`, stop — those are edge-function secrets. See
// docs/ENVIRONMENT.md.
import { createClient, type SupabaseClient } from '@supabase/supabase-js'

export const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? '') as string
export const SUPABASE_PUBLISHABLE_KEY = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  '') as string

/** False when the build had no Supabase env vars — the shell still renders. */
export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY)

// `bun run build` must succeed on a fresh clone with no .env, so this module can
// never throw at import time — a throw here white-screens the whole SPA. Fall
// back to the local `supabase start` defaults and complain loudly instead.
const LOCAL_URL = 'http://127.0.0.1:54321'
const LOCAL_KEY = 'public-anon-key'

if (!isSupabaseConfigured) {
  console.error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY — falling back to the local ' +
      `Supabase defaults (${LOCAL_URL}). Copy .env.example to .env. See docs/ENVIRONMENT.md.`,
  )
}

export const supabase: SupabaseClient = createClient(
  isSupabaseConfigured ? SUPABASE_URL : LOCAL_URL,
  isSupabaseConfigured ? SUPABASE_PUBLISHABLE_KEY : LOCAL_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Completes the magic-link round trip: the user lands back on
      // /join?code=XYZ with the session in the URL hash and this picks it up.
      detectSessionInUrl: true,
    },
  },
)

/** Base URL for edge functions: `${FUNCTIONS_URL}/health`, `${FUNCTIONS_URL}/trips`, … */
export const FUNCTIONS_URL = `${isSupabaseConfigured ? SUPABASE_URL : LOCAL_URL}/functions/v1`
